import { useInfiniteQuery } from 'react-query';

import getNotifications from '@/common/api/notifications/getNotifications';

const useNotifications = (queryKey, params) =>
  useInfiniteQuery(
    queryKey,
    ({ pageParam = 1 }) => getNotifications({ queryKey, pageParam }, params),
    {
      getNextPageParam: (lastPage) => {
        const currentPage = lastPage.meta.current_page;
        const totalPages = lastPage.meta.total_pages;

        return currentPage < totalPages ? currentPage + 1 : null;
      },
    },
  );

export default useNotifications;
